import { Header } from '@asgard/ui-library';
import { TalentIntroStyles as S } from './TalentIntro.styles';
import { TalentIntroProps } from './TalentIntro.types';

export const TalentIntro: React.FC<TalentIntroProps> = ({
  title,
  desc,
  prepend,
  ...rest
}) => {
  return (
    <S.Root {...rest}>
      {prepend && <p>{prepend}</p>}
      <Header editorial as="h2" size="5xl">
        {title}
      </Header>
      {desc && <p>{desc}</p>}
    </S.Root>
  );
};
